// src/routes/AdminRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import DashboardLayout from '../pages/Admin/DashboardLayout';
import Overview from '../pages/Admin/Overview';
import OrdersPage from '../pages/Admin/Orders';
import OrderDetail from '../pages/Admin/Orders/OrderDetail';
import ProductsPage from '../pages/Admin/Products';
import UsersPage from '../pages/Admin/Users';
import VerificationsPage from '../pages/Admin/Verifications/VerificationsPage';
import WarehouseDashboard from '../pages/Admin/Warehouse/Dashboard';
import ShipmentDetail from '../pages/Admin/Warehouse/ShipmentDetail';
import VendorApplications from '../pages/Admin/VendorManagement/VendorApplications';
import ApplicationDetail from '../pages/Admin/VendorManagement/VendorApplications/ApplicationDetail';
import VendorList from '../pages/Admin/VendorManagement/VendorList';
import VendorDetail from '../pages/Admin/VendorManagement/VendorDetail';
import VendorProducts from '../pages/Admin/VendorManagement/VendorProducts';
import VendorOrders from '../pages/Admin/VendorManagement/VendorOrders';
import VendorPayouts from '../pages/Admin/VendorManagement/VendorPayouts';
import VendorSettings from '../pages/Admin/VendorManagement/VendorSettings';
import TypeChangeRequests from '../pages/Admin/VendorManagement/TypeChangeRequests';
import VendorManagement from '../pages/Admin/VendorManagement';

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route index element={<Overview />} />
        {/* <Route path="orders">
          <Route index element={<OrdersPage />} />
          <Route path=":orderId" element={<OrderDetail />} />
        </Route> */}
        <Route path="products">
          <Route index element={<ProductsPage />} />
          <Route path="new" element={<div>Create Product (Coming Soon)</div>} />
          <Route path=":id/edit" element={<div>Edit Product (Coming Soon)</div>} />
        </Route>
        <Route path="users">
          <Route index element={<UsersPage />} />
          <Route path=":id" element={<div>User Details (Coming Soon)</div>} />
        </Route>
        <Route path="verifications">
          <Route index element={<VerificationsPage />} />
          <Route path="identity/:id" element={<div>Identity Verification (Coming Soon)</div>} />
          <Route path="address/:id" element={<div>Address Verification (Coming Soon)</div>} />
        </Route>
        <Route path="drivers" element={<div>Drivers Management (Coming Soon)</div>} />
        <Route path="settings" element={<div>Settings (Coming Soon)</div>} />
        <Route path="orders">
          <Route index element={<OrdersPage />} />
          <Route path=":orderNumber" element={<OrderDetail />} />
        </Route>
        <Route path="warehouse">
          <Route index element={<WarehouseDashboard />} />
          <Route path="shipment/:shipmentId" element={<ShipmentDetail />} />
        </Route>
        <Route path="vendor-applications" element={
          <VendorApplications />
        } />
        <Route path="vendor-applications/:id" element={
          <ApplicationDetail />
        } />
        <Route path="vendors" element={<VendorManagement />}>
          <Route index element={<VendorList />} />
          <Route path="type-changes" element={<TypeChangeRequests />} />
          <Route path="applications" element={<VendorApplications />} />
          <Route path=":id" element={<VendorDetail />}>
            {/* Nested routes inside VendorDetail */}
            {/* <Route index element={<VendorOverview />} /> */}
            <Route path="products" element={<VendorProducts />} />
            <Route path="orders" element={<VendorOrders />} />
            <Route path="payouts" element={<VendorPayouts />} />
            <Route path="settings" element={<VendorSettings />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default AdminRoutes;